require('./dirPagination');
module.exports = 'angularUtils.directives.dirPagination';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-utils-pagination/index.js
 ** module id = 10
 ** module chunks = 0
 **/